/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AuthService from "../../base/services/authentication.service";
import "./custom.css";
import ForgotPassword from "./ForgotPassword";
import LastPage from "./messagePages/LastPage";
import RequestPage from "./messagePages/RequestPage";
import AuthLayout from "./layout/AuthLayout";
import Login from "./Login";
import Registration from "./Registration";
import RegistrationStep2 from "./RegistrationStep2";
import RegistrationStep3 from "./RegistrationStep3";
import ConfirmCode from "./ConfirmCode";
import VerificationCodeAndSignIn from "./VerificationCodeAndSignIn";
import ForgotPasswordConfirm from "./ForgotPasswordConfirm";
import ForgotPasswordSetNew from "./ForgotPasswordSetNew";
import "../../assets/styles/login-1.css";
import RegistrationOfNationalOrganization from "./RegistrationOfNationalOrganization";
import RegistrationOfInternationalDonor from "./RegistrationOfInternationalDonor";
import RegistrationOfVendor from "./RegistrationOfVendor";
/* route protection will be applied after regist / auth apis are connected */

export function AuthPage() {
   const [isAuthorized, setisAuth] = useState(false);

   const location = useLocation();

   useEffect(() => {
      setisAuth(AuthService.isAuthenticated());
   }, [location, setisAuth]);

   return (
      <>
         <Routes>
            {isAuthorized ? (
               /*Render auth page when user at `/auth` and not authorized.*/
               <Route path="/*" element={<Navigate to="/" />} />
            ) : (
               <>
                  <Route element={<AuthLayout />}>
                     <Route path="/auth/login" element={<Login />} />
                     <Route path="/auth/registration" element={<Registration />} />
                     <Route
                        path="/auth/national-org-registration"
                        element={<RegistrationOfNationalOrganization />}
                     />
                     <Route
                        path="/auth/international-donor-registration"
                        element={<RegistrationOfInternationalDonor />}
                     />
                     <Route path="/auth/vendor-registration" element={<RegistrationOfVendor />} />
                     <Route path="/auth/confirm-code" element={<ConfirmCode />} />
                     <Route path="/auth/confirm-request" element={<VerificationCodeAndSignIn />} />
                     <Route path="/auth/register-organization" element={<RegistrationStep2 />} />
                     <Route path="/auth/request-approval" element={<RegistrationStep3 />} />
                     <Route path="/auth/forgot-password" element={<ForgotPassword />} />
                     <Route path="/auth/password-confirm" element={<ForgotPasswordConfirm />} />
                     <Route path="/auth/generate-password" element={<ForgotPasswordSetNew />} />
                     <Route path="/*" element={<Navigate to="/auth/login" />} />
                  </Route>
                  <Route path="/auth/success" element={<LastPage />} />
                  <Route path="/auth/request" element={<RequestPage />} />
               </>
            )}
         </Routes>
      </>
   );
}
